export default "__VITE_ASSET__BHkUSnGs__"